import React, { MutableRefObject, createContext, useContext, useRef } from 'react';
import { OutboundSession } from './OutboundSession';

export const OutboundContext = createContext<{
  session: MutableRefObject<OutboundSession>;
}>({
  // HACK: It looks like there's no way to not provide a default, but we
  // want to try as hard as possible to ensure that there's a singleton
  // session for the whole time the agent interacts with the app.
  session: { current: undefined as any },
});

export const useOutboundContext = () => {
  return useContext(OutboundContext);
};

export const OutboundProvider: React.FC = ({ children }) => {
  const session = useRef(new OutboundSession());
  return (
    <OutboundContext.Provider value={{ session: session }}>
      {children}
    </OutboundContext.Provider>
  );
};
